import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./common/Header";
import Footer from "./common/Footer";
import SEO from "./SEO";

const Nomatch = () => {
  useEffect(() => {
    if (window.AOS) window.AOS.init();
  }, []);

  return (
    <>
      <SEO
        title="404 - Page Not Found | Bowinkles Drive Thru"
        description="The page you are looking for does not exist. Return to Bowinkles Drive Thru homepage to explore our menu and locations."
        keywords="404, page not found, Bowinkles Drive Thru"
      />
      <Header />
      <div className="noMatchcontainer">

      <div className="bgimage">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10">
              <div className="bgContent">
                <div className="overlay-404">
                  <div data-aos="fade-down" data-aos-once="true" className="error-content">
                    <div className="error-number">
                      <span className="bigText">4</span>
                      <i className="fas fa-hamburger error-icon"></i>
                      <span className="bigText">4</span>
                    </div>
                    <h2 className="error-title">
                      &#10035; Sorry, no food here! &#10035;
                    </h2>
                    <p className="error-message">
                      The page you're looking for doesn't exist or has been moved.
                      Don't worry though - we've got plenty of delicious food waiting for you!
                    </p>
                    <Link to="/">
                      <button className="error-button" id="uniqueButton">
                        <i className="fas fa-home me-2"></i>
                        Back to Homepage
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
    </>
  );
};

export default Nomatch;
